import React from 'react'
import { connect } from 'react-redux'
import SignatureCanvas from 'react-signature-canvas'
import styled from 'styled-components';
import actions from '../../redux/actions'
import {Button} from 'antd';
import Layout from '../../components/Layout'
import constants from '../../config/constants'
import ButtonComponent from '../../components/Button';

import signatureIcon from '../../assets/images/orangeSignature.png'

const Container = styled.div`
  padding: 2rem 0 1rem;
  overflow-y: scroll;
  scroll-behavior: smooth;
`

const SigContainer = styled.div`
  background-color: ${constants.color.white};
  border: 1px solid ${constants.color.lightDark};
  border-radius: 8px;
  margin: 1rem 0;
  overflow: hidden;
  width: 100%;
  height: 280px;
  display: block;
  position: relative;
`

const SigImage = styled.img`
  background-size: 200px 50px;
  width: 200px;
  height: auto;
  background-color: ${constants.color.white};
`
const SignatureStyled = styled(SignatureCanvas)`
  width: 100%;
  height: 100%;
`

const Title  = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: ${constants.color.lightDark};
`

const StyledMainButton = styled.div`
  text-align: center;
  width: 100%;
  margin: .5rem 0 2rem;
`;

const StyledButton = styled(Button)`
  height: 30px !important;
  color: ${constants.color.orange} !important;
  background-color: ${constants.color.white} !important;
  border-color: ${constants.color.orange} !important;
  width: 30% !important;
  border-radius: 25px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin: 0 auto;

  span {
    font-family: Thonburi Bold;
    font-size: 14px !important;
    margin-left: 0.2rem;
  }

  img {
    height: auto;
    width: 25px;
  }
`;

class Signature extends React.Component {
  state = { showTitle: true }

  sigPad = {}

  clear = () => {
    this.sigPad.clear()
    this.setState({ showTitle: true })
  }

  trim = () => {
    const trimmedDataURL = this.sigPad.getTrimmedCanvas().toDataURL('image/png');
    this.props.setSignaturePicture(trimmedDataURL);
    this.props.history.push('/upload-document');
  }

  handelSignatureChange = () => {
    this.setState({ showTitle: false })
  }

  render () {
      const { trimmedDataURL } = this.state
      const width = window.innerWidth;
      return (
        <Layout title={'เซ็นชื่อของคุณ'} backIcon={true} onClick={() => this.props.history.goBack()}>
          <Container>
            <h5>กรุณาเซ็นชื่อของคุณด้านล่าง</h5>
              <SigContainer>
                <SignatureStyled
                  onBegin={this.handelSignatureChange.bind(this)}
                  ref={(ref) => { this.sigPad = ref }}
                  canvasProps={{width: width - 30 , height: 280, className: 'sigCanvas'}} />
                {this.state.showTitle && <Title>เซ็นชื่อที่นี่</Title>}
              </SigContainer>
              <StyledMainButton>
                <StyledButton onClick={this.clear}>
                  <img src={signatureIcon} alt=""/> เซ็นใหม่
                </StyledButton>
              </StyledMainButton>
              <ButtonComponent
                textcolor={constants.color.white}
                bordercolor={constants.color.orange}
                backgroundcolor={constants.color.orange}
                text={'บันทึก'}
                disabled={false}
                onClick={this.trim}/>
              {trimmedDataURL ? <SigImage src={trimmedDataURL} /> : null}
          </Container>
          </Layout>)
  }
}

const mapDispatchToProps = {
  setSignaturePicture: actions.setSignaturePicture,
}

const SignatureWithConnect = connect(null, mapDispatchToProps)(Signature)

export default SignatureWithConnect
